import defaults from 'lodash/defaults.js';
import extend from 'lodash/extend.js';
import isString from 'lodash/isString.js';
import once from 'lodash/once.js';
import { hooks } from '../wpHooks/index.js';
import { warnLog } from '../utils/log.js';
let config;
export function setConfig(_config) {
    return once(() => {
        config = _config;
        const { experimentalPlugins, plugins } = _config;
        // combine both sets of plugins until experimentalPlugins is fully deprecated
        const allSupportedPlugins = [
            ...(experimentalPlugins || []),
            ...(plugins || []),
        ];
        allSupportedPlugins === null || allSupportedPlugins === void 0 ? void 0 : allSupportedPlugins.forEach((plugin) => {
            var _a;
            (_a = plugin === null || plugin === void 0 ? void 0 : plugin.apply) === null || _a === void 0 ? void 0 : _a.call(plugin, hooks);
        });
        if (experimentalPlugins === null || experimentalPlugins === void 0 ? void 0 : experimentalPlugins.length) {
            // log to cli if experimentalPlugins is used since it's being deprecated
            warnLog('Plugin System: The "experimentalPlugins" configuration option will be deprecated in the near future. Please use "plugins" instead in the faust.config.js.');
        }
    })();
}
export function normalizeConfig(_config) {
    const cfg = defaults({}, _config, {
        loginPagePath: '/login',
        experimentalToolbar: false,
        usePersistedQueries: false,
        useGETForQueries: true,
        basePath: '',
    });
    Object.keys(cfg).forEach((key) => {
        const keyValue = key;
        const value = cfg[keyValue];
        if (isString(value)) {
            cfg[keyValue] = value.trim();
        }
    });
    return extend(cfg, {});
}
export function getConfig() {
    return normalizeConfig(config);
}
